// extracted by mini-css-extract-plugin
export default {"wrapper":"Breadcrumbs_wrapper__o6WlE","arrow":"Breadcrumbs_arrow__D1He6","item":"Breadcrumbs_item__KnbG1","currentItem":"Breadcrumbs_currentItem__NInSX"};